import React from "react"

import LandingBio from "../components/landing-bio"
import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`Agile`, `Scrum`, `Scrum Master`, `Agile Coach`, `Management 3.0`, `Facilitation`, `Retrospective`, `react`]} />
    <LandingBio />
  </Layout>
)

export default IndexPage
